import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CheckCircle2 } from "lucide-react";
import { processData } from "../../../../data/howItWorks/processData";
import "./ProcessDetails.css";

gsap.registerPlugin(ScrollTrigger);

const ProcessDetails = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const cards = sectionRef.current.querySelectorAll(".detail-card");

      cards.forEach((card, index) => {
        const content = card.querySelector(".detail-card__content");
        const imageWrapper = card.querySelector(".detail-card__image");
        const isReverse = index % 2 !== 0;

        gsap.fromTo(
          content,
          { opacity: 0, x: isReverse ? 60 : -60 },
          {
            opacity: 1,
            x: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 75%",
              toggleActions: "play none none none",
              once: true,
            },
          },
        );

        gsap.fromTo(
          imageWrapper,
          { opacity: 0, x: isReverse ? -60 : 60 },
          {
            opacity: 1,
            x: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 75%",
              toggleActions: "play none none none",
              once: true,
            },
          },
        );
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="process-details" ref={sectionRef}>
      <div className="process-details__container">
        {processData.detailedSteps.map((step, index) => (
          <div
            key={step.step}
            className={`detail-card ${index % 2 !== 0 ? "detail-card--reverse" : ""}`}
          >
            <div className="detail-card__content">
              <div className="detail-card__step-number">{step.step}</div>
              <h3 className="detail-card__title">{step.title}</h3>
              <h2 className="detail-card__headline">{step.headline}</h2>
              <p className="detail-card__description">{step.description}</p>

              <div className="detail-card__features">
                <h4 className="detail-card__features-title">What We Do:</h4>
                <ul className="detail-card__features-list">
                  {step.features.map((feature, idx) => (
                    <li key={idx} className="detail-card__feature">
                      <CheckCircle2 size={20} strokeWidth={2.5} />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="detail-card__result">
                <strong>Result:</strong> {step.result}
              </div>
            </div>

            <div className="detail-card__image">
              <img src={step.image} alt={step.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessDetails;
